import React from 'react';
import HeaderButton from '../HeaderButton';
import SearchComponent from './SearchComponent';
import './styles.scss';

const Search = () => {
    const [isOpen, setOpen] = React.useState(false);

    const onToggleSearch = () => setOpen(!isOpen);

    return (
        <div className="search-container">
            <HeaderButton iconName={isOpen ? 'close' : 'search'} onClick={onToggleSearch} />
            {isOpen && (
                <div className={`search-dropdown ${isOpen ? 'opened' : ''}`}>
                    <SearchComponent />
                </div>
            )}
        </div>
    );
};

export default Search;
